﻿﻿﻿<template>
  <div class="app-container">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="flexs mb20">
        <el-image style="width: 50px; height: 50px;border-radius: 50%;" :src="info.userPO.headImg" v-if="info.userPO && info.userPO.headImg" :preview-src-list="[info.userPO.headImg]"></el-image>
        <img style="width: 50px; height: 50px;" src="@/assets/du_logo.png" v-else />
        <div class="ml10">
          <div class="flexs">
            <span class="font16">{{info.customerPO.name}}</span>
            <i style="font-size: 13px;" :class="info.customerPO.sex==1?'el-icon-male':'el-icon-female'" :style="{'color':info.customerPO.sex==1?'#60B7DC':'#F59494'}" class="ml5"></i>
            <div class="font12 label-box ml5">{{info.customerPO.clevelName}}</div>
          </div>
          <div class="flexs mt5" v-if="info.tagYW && info.tagYW.length">
            <span class="font14 c-8F8E8E">业务标签：</span>
            <div v-for="item in info.tagYW" :key="item.id" class="font12 label-boxs ml5">{{item.name}}</div>
          </div>
          <div class="flexs mt5" v-if="info.tagJS && info.tagJS.length">
            <span class="font14 c-8F8E8E">技术标签：</span>
            <div v-for="item in info.tagJS" :key="item.id" class="font12 label-boxs ml5">{{item.name}}</div>
          </div>
        </div>
      </div>
      <div>
        <el-descriptions title="" direction="vertical" :column="10" :colon="false">
          <el-descriptions-item label="客户ID" label-class-name="c-8F8E8E">{{info.customerPO.id}}</el-descriptions-item>
          <el-descriptions-item label="用友编码" label-class-name="c-8F8E8E">{{info.customerPO.code}}</el-descriptions-item>
          <el-descriptions-item label="电话" label-class-name="c-8F8E8E">{{info.customerPO.pho}}</el-descriptions-item>
          <el-descriptions-item label="客户来源" label-class-name="c-8F8E8E">{{info.customerPO.source}}</el-descriptions-item>
          <el-descriptions-item label="所在区域" label-class-name="c-8F8E8E" v-if="info.addr && info.addr.length" :span="2">{{info.addr[0].regionName}}{{info.addr[1].regionName}}{{info.addr.length==3?info.addr[2].regionName:''}}</el-descriptions-item>
          <el-descriptions-item label="账号类型" label-class-name="c-8F8E8E">{{info.customerPO.mainId?'子账号':'主账号'}}</el-descriptions-item>
          <el-descriptions-item label="通商云ID" label-class-name="c-8F8E8E">{{info.userPO.bizUserId}}</el-descriptions-item>
          <!-- <el-descriptions-item label="邀请业务员" label-class-name="c-8F8E8E">暂无字段</el-descriptions-item> -->
          <el-descriptions-item label="客户分类" label-class-name="c-8F8E8E">{{info.customerClassify && info.customerClassify.name?info.customerClassify.name:''}}</el-descriptions-item>
          <el-descriptions-item label="注册app时间" label-class-name="c-8F8E8E">{{info.customerPO.createdTime}}</el-descriptions-item>
          <el-descriptions-item label="注册时身份" label-class-name="c-8F8E8E">{{info.firstLevelName}}</el-descriptions-item>
          <el-descriptions-item label="刷脸信息" label-class-name="c-8F8E8E">{{info.faceInfo && info.faceInfo.certificateStatus?'已认证':'未认证'}}</el-descriptions-item>
          <el-descriptions-item label="子账号" label-class-name="c-8F8E8E" v-if="!info.customerPO.mainId">{{info.subCount}}</el-descriptions-item>
          <el-descriptions-item label="绑定业务员" label-class-name="c-8F8E8E">{{info.parent?info.parent.name:''}}</el-descriptions-item>
          <el-descriptions-item label="绑定技术老师" label-class-name="c-8F8E8E">{{info.technician?info.technician.realName:''}}</el-descriptions-item>
          <el-descriptions-item label="绑定带教老师" label-class-name="c-8F8E8E">{{info.technicianForBig?info.technicianForBig.realName:''}}</el-descriptions-item>
          <el-descriptions-item label="账户状态" label-class-name="c-8F8E8E">{{!info.customerPO.state?'禁用':info.customerPO.state==1?'启用':info.customerPO.state==-1?'驳回':info.customerPO.state==2?'待审核':'撤回'}}</el-descriptions-item>
          <el-descriptions-item label="登录状态" label-class-name="c-8F8E8E">{{info.userPO.entryInhibited?'禁用':'启用'}}</el-descriptions-item>
          <el-descriptions-item label="合同到期时间" label-class-name="c-8F8E8E">{{formatContractExpiration(info.customerPO.contractExpirationTime)}}</el-descriptions-item>
          <el-descriptions-item label="修改身份备注" label-class-name="c-8F8E8E">{{info.customerPO.lastDonote}}</el-descriptions-item>
          <!-- <el-descriptions-item label="是否禁止登录"
            label-class-name="c-8F8E8E">{{info.userPO.entryInhibited?'是':'否'}}</el-descriptions-item> -->
        </el-descriptions>
      </div>
      <portrait-summary :customer-id="rowId" @view-logs="activeName = 'portraitLogs'" />
      <el-tabs v-model="activeName" @tab-click="" class="mt20">
        <el-tab-pane label="基础信息" name="1"></el-tab-pane>
        <el-tab-pane label="订单统计" name="2"></el-tab-pane>
        <el-tab-pane label="课程信息" name="3" v-if="!info.customerPO.mainId"></el-tab-pane>
        <el-tab-pane label="会议记录" name="4"></el-tab-pane>
        <!-- <el-tab-pane :label="`子账号(${list.length})`" name="5"></el-tab-pane> -->
        <el-tab-pane label="账户明细" name="6"></el-tab-pane>
        <el-tab-pane label="业务跟进" name="7"></el-tab-pane>
        <el-tab-pane label="技术跟进" name="8"></el-tab-pane>
        <el-tab-pane label="服务跟进" name="11"></el-tab-pane>
        <el-tab-pane label="其他跟进" name="12"></el-tab-pane>
        <el-tab-pane label="画像与服务标记" name="portrait"></el-tab-pane>
        <el-tab-pane label="标记日志" name="portraitLogs"></el-tab-pane>
        <el-tab-pane label="用户轨迹" name="9"></el-tab-pane>
        <el-tab-pane label="店铺介绍" name="10"></el-tab-pane>
      </el-tabs>
      <portrait-records v-if="activeName === 'portrait' || activeName === 'portraitLogs'"
                       :key="activeName" :customer-id="rowId" :logs="activeName === 'portraitLogs'" />
      <template v-if="activeName==1">
        <div class="flexs mt20" v-if="!info.customerPO.mainId">
          <div v-for="(item,index) in stepList" :key="index" class="relative step-box font14">
            <el-image :src="require(`@/assets/step${item.isActive?'_active':''}.png`)" v-if="!index" />
            <el-image :src="require(`@/assets/step2${item.isActive?'_active':''}.png`)" alt="" v-else-if="index==stepList.length-1" />
            <el-image :src="require(`@/assets/step1${item.isActive?'_active':''}.png`)" alt="" v-else />
            <div class="absolute w-100 h-100 flexs justify-center" :class="item.isActive?'c-fff':'c-8F8E8E'">
              {{item.label}}</div>
          </div>
        </div>
        <Title class="mt40">实名认证：<span :style="{'color': getCertStatusColor(info.certificatesPO, info.certificatesPO && info.certificatesPO.auditStatus)}">{{getCertStatusText(info.certificatesPO, info.certificatesPO && info.certificatesPO.auditStatus)}}</span></Title>
        <el-descriptions title="" v-if="info.certificatesPO && info.certificatesPO.certificatesType==1">
          <el-descriptions-item label="认证类型">企业认证</el-descriptions-item>
          <el-descriptions-item label="门店类型">{{info.certificatesPO.companyType?getCompanyTypeName(info.certificatesPO.companyType):getCompanyTypeName(info.certificatesPO.waitCompanyType)}}</el-descriptions-item>
          <el-descriptions-item label="企业全称">{{info.certificatesPO.companyName}}</el-descriptions-item>
          <!-- <el-descriptions-item label="所在地">{{info.customerCertificates.companyType}}</el-descriptions-item> -->
          <el-descriptions-item label="资质证件类型">{{info.certificatesPO.companyZiZhi==2?'医疗机构职业许可证':'营业执照'}}</el-descriptions-item>
          <el-descriptions-item label="统一社会信用代码">{{info.certificatesPO.code}}</el-descriptions-item>
          <el-descriptions-item label="纳税人识别号">{{info.certificatesPO.taxpayerCode}}</el-descriptions-item>
          <el-descriptions-item label="提交认证时间">{{dayjs(info.certificatesPO.createdTime).format("YYYY-MM-DD HH:mm:ss")}}</el-descriptions-item>
          <el-descriptions-item label="资质证件">
            <el-image style="width: 150px;" :src="info.certificatesPO.certificatesImg" :preview-src-list="[info.certificatesPO.certificatesImg]"></el-image>
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions title="" v-if="info.certificatesPO && info.certificatesPO.certificatesType==2">
          <el-descriptions-item label="认证类型">个人认证</el-descriptions-item>
          <el-descriptions-item label="姓名">{{info.certificatesPO.companyName}}</el-descriptions-item>
          <el-descriptions-item label="身份证号">{{info.certificatesPO.code}}</el-descriptions-item>
          <el-descriptions-item label="提交认证时间">{{dayjs(info.certificatesPO.createdTime).format("YYYY-MM-DD HH:mm:ss")}}</el-descriptions-item>
          <el-descriptions-item label="身份证">
            <el-image style="width: 150px;" :src="info.certificatesPO.certificatesImg.split(',')[0]" :preview-src-list="info.certificatesPO.certificatesImg.split(',')"></el-image>
            <el-image style="width: 150px;" class="ml10" :src="info.certificatesPO.certificatesImg.split(',')[1]" :preview-src-list="info.certificatesPO.certificatesImg.split(',')"></el-image>
          </el-descriptions-item>
        </el-descriptions>
        <div v-if="info.customerPO.mainId && info.mainCustomerPO">
          <Title class="mt20">主账号信息</Title>
          <el-descriptions title="">
            <el-descriptions-item label="姓名">{{info.mainCustomerPO.name}}</el-descriptions-item>
            <el-descriptions-item label="身份">{{info.mainCustomerLevel ? info.mainCustomerLevel.name : ''}}</el-descriptions-item>
            <el-descriptions-item label="手机号">{{info.mainCustomerPO.pho}}</el-descriptions-item>
          </el-descriptions>
        </div>
        <!-- <Title class="mt20">分润比例</Title>
        <el-descriptions title="">
            <el-descriptions-item label="研修班">kooriookami</el-descriptions-item>
            <el-descriptions-item label="体验班">18100000000</el-descriptions-item>
        </el-descriptions> -->
        <Title class="mt20" v-if="!info.customerPO.mainId && info.contractList  && info.contractList.length">合同信息</Title>
        <div v-if="!info.customerPO.mainId && info.contractList  && info.contractList.length" class="font14" style="color: rgb(96, 98, 102);display: flex;">
          <!-- <div style="margin-right: 300px;">合同：{{info.contractList[0].contractName}} <span v-if="info.contractList[0].stateName">【{{info.contractList[0].stateName}}】</span></div> -->
          <div style="display: flex;" class="font14">合同：<div>
              <div v-for="item in info.contractList" :key="item.id" class="mb10">《{{item.contractName}}》
                <span v-if="item.stateName">【{{item.stateName}}】</span>
                <a v-if="contractUrl(item.shortUrl)" :href="contractUrl(item.shortUrl)" target="_blank" rel="noopener noreferrer">【查看合同】</a>
                <span v-else-if="item.shortUrl">【合同链接不可用】</span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div v-for="item in arr.splice(0,1)">{{item}}</div> -->

        <Title class="mt20">从属关系</Title>
        <el-descriptions title="">
          <el-descriptions-item label="技术线" :span="12">{{technicianLine || ''}}</el-descriptions-item>
          <el-descriptions-item label="业务线" :span="12">{{customerLine || ''}}</el-descriptions-item>
          <!-- <el-descriptions-item label="城市公司" :span="12">{{info.cityCompany?info.cityCompany.name : ''}}</el-descriptions-item> -->
        </el-descriptions>
        <Title class="mt20" v-if="info.customerPO.clevel!=8 && !info.customerPO.mainId">报名费用</Title>
        <div v-if="info.customerPO.clevel!=8 && !info.customerPO.mainId">
          <el-descriptions title="" v-for="item in info.registrationList" :key="item.id" class="box-sty">
            <!-- <el-descriptions-item label="报名体验班方式">kooriookami</el-descriptions-item> -->
            <el-descriptions-item :label="`报名${item.levelId==7?'体验班':'研修班'}时间`">{{item.payTime}}</el-descriptions-item>
            <el-descriptions-item :label="`${item.levelId==7?'体验班':'研修班'}学费`">{{item.fee}}元</el-descriptions-item>
            <el-descriptions-item label="申请编号">{{item.num}}</el-descriptions-item>
            <el-descriptions-item label="申请时间">{{dayjs(item.createdTime).format("YYYY-MM-DD HH:mm:ss")}}</el-descriptions-item>
            <el-descriptions-item label="提交人">{{item.createdUserPO?item.createdUserPO.realName:''}}【{{item.createdUserLevelName}}】</el-descriptions-item>
            <el-descriptions-item label="申请结果">{{item.state==1?'已通过':item.state==2?'未通过':'审核中'}}</el-descriptions-item>
            <el-descriptions-item :label="`${item.levelId==7?'体验班':'研修班'}付款凭证`" :span="12" v-if="item.payList">
              <el-image style="width: 180px;height: 120px;" :src="it.payImg" :preview-src-list="[it.payImg]" fit="cover" v-for="(it, payIndex) in item.payList" :key="`${item.id}-pay-${it.id || payIndex}`" class="mr10"></el-image>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <Title class="mt20" v-if="!info.customerPO.mainId">其他信息</Title>
        <el-descriptions title="" v-if="!info.customerPO.mainId">
          <el-descriptions-item label="日均门诊量">{{info.customerPO.shopOutpatient}}</el-descriptions-item>
          <el-descriptions-item label="员工数量">{{info.customerPO.shopCount}}</el-descriptions-item>
          <el-descriptions-item label="正在开展项目" v-if="info.customerPO.carryProjects">{{info.customerPO.carryProjects}}</el-descriptions-item>
          <el-descriptions-item label="微信号">{{info.customerPO.wechat}}</el-descriptions-item>
          <el-descriptions-item label="备注">{{info.customerPO.note}}</el-descriptions-item>
        </el-descriptions>
        <Title class="mt20" v-if="info.customerPO.mainId">子账号申请信息</Title>
        <el-descriptions title="" v-if="info.customerPO.mainId">
          <el-descriptions-item label="申请编号">{{subaccountInfo.approvalNumber}}</el-descriptions-item>
          <el-descriptions-item label="申请时间">{{dayjs(subaccountInfo.submitTime).format("YYYY-MM-DD HH:mm:ss")}}</el-descriptions-item>
          <el-descriptions-item label="申请人">{{subaccountInfo.applyName}}【{{subaccountInfo.applyLevelName	}}】</el-descriptions-item>
          <el-descriptions-item label="通过时间">{{subaccountInfo.auditTime}}</el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-if="activeName==2">
        <Title class="mt20">统计</Title>
        <el-descriptions title="">
          <el-descriptions-item label="总订单金额">{{allStatistics.goodsPayMoney}}元</el-descriptions-item>
          <el-descriptions-item label="现金">{{allStatistics.moneyForPayType5}}元</el-descriptions-item>
          <el-descriptions-item label="余额">{{allStatistics.moneyForPayType2}}元</el-descriptions-item>
          <el-descriptions-item label="零售价">{{allStatistics.moneyForPayType1}}元</el-descriptions-item>
          <el-descriptions-item label="学费增额">{{allStatistics.moneyForPayType4}}元</el-descriptions-item>
        </el-descriptions>
        <Title class="mt20">订货订单</Title>
        <el-descriptions title="">
          <el-descriptions-item label="总订单金额">{{orderStatistics.goodsPayMoney}}元</el-descriptions-item>
          <el-descriptions-item label="现金">{{orderStatistics.moneyForPayType5}}元</el-descriptions-item>
          <el-descriptions-item label="余额">{{orderStatistics.moneyForPayType2}}元</el-descriptions-item>
          <el-descriptions-item label="零售价">{{orderStatistics.moneyForPayType1}}元</el-descriptions-item>
          <el-descriptions-item label="学费增额">{{orderStatistics.moneyForPayType4}}元</el-descriptions-item>
        </el-descriptions>
        <Title class="mt20">秒杀订单</Title>
        <el-descriptions title="">
          <el-descriptions-item label="总订单金额">{{seckillStatistics.goodsPayMoney}}元</el-descriptions-item>
          <el-descriptions-item label="现金">{{seckillStatistics.moneyForPayType5}}元</el-descriptions-item>
          <!-- <el-descriptions-item label="余额">{{seckillStatistics.moneyForPayType2}}元</el-descriptions-item>
          <el-descriptions-item label="零售价">{{seckillStatistics.moneyForPayType1}}元</el-descriptions-item>
          <el-descriptions-item label="学费增额">{{seckillStatistics.moneyForPayType4}}元</el-descriptions-item> -->
        </el-descriptions>
        <Title class="mt20">
          月度对比
          <el-select v-model="monthYear" size="mini" class="ml10" style="width:120px" @change="getMonthStatistics">
            <el-option v-for="y in yearOptions" :key="y" :label="y + '年'" :value="y" />
          </el-select>
        </Title>
        <el-table v-loading="monthLoading" :data="monthList" size="small" show-summary :summary-method="monthSummary">
          <el-table-column label="月份" align="center">
            <template slot-scope="{row}">{{ row.month }}月</template>
          </el-table-column>
          <!-- REQ-2026-911648：「实际出货业绩」列已下线（用户 2026-09-22 拍板），
               该数字改由 App「销量对比」页展示。接口仍返 shipmentMoney，此处只是不展示。 -->
          <el-table-column label="订单单量" prop="orderCount" align="center" />
        </el-table>
      </template>
      <template v-if="activeName==3">
        <Title class="mt20">统计</Title>
        <el-descriptions title="">
          <el-descriptions-item label="赠送(次数)">{{courseInfo.giveCount}}</el-descriptions-item>
          <el-descriptions-item label="购买">{{courseInfo.buyCount}}节课</el-descriptions-item>
          <el-descriptions-item label="支付金额">{{courseInfo.totalPayAmount}}元</el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-if="activeName==4">
        <Title class="mt20">统计</Title>
        <el-descriptions title="">
          <el-descriptions-item label="报名会议">{{meetingInfo.count}}次</el-descriptions-item>
          <el-descriptions-item label="签到会议">{{meetingInfo.signInCount}}次</el-descriptions-item>
          <el-descriptions-item label="未签到">{{meetingInfo.notSignInCount}}次</el-descriptions-item>
          <el-descriptions-item label="报名费用">{{meetingInfo.fee}}元</el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-if="activeName==6">
        <el-descriptions title="">
          <el-descriptions-item label="余额">{{walletInfo.balance}}</el-descriptions-item>
          <el-descriptions-item label="零售价">{{walletInfo.xiaoduMoney}}</el-descriptions-item>
          <el-descriptions-item label="学费赠送">{{walletInfo.tuition}}</el-descriptions-item>
          <el-descriptions-item label="积分">{{walletInfo.integral}}</el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-if="activeName==7">
        <el-timeline v-if="customerList.length">
          <el-timeline-item v-for="(item, index) in customerList" :key="index" type="primary">
            <div class="boxs">
              <div class="flexs justify-between mb10">
                <span class="c-8F8E8E">{{item.createdTime}} 星期{{setWeek(dayjs(item.createdTime).day())}}</span>
                <span class="c-8F8E8E" v-if="item.followUpByRealName">跟进人：{{item.followUpByRealName}}<template v-if="item.followUpByType">（{{item.followUpByType}}）</template></span>
              </div>
              <div class="mt10 c-8F8E8E" v-if="item.followUpCategoryId">跟进类型：{{getFollowUpCategoryName(item.followUpCategoryId)}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.followUpType">跟进方式：{{item.followUpType==1?'线下会面':'线上沟通'}}</div>
              <div class="mt10 c-8F8E8E">跟进内容：{{item.followUpContent}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.followUpPurpose">跟进目的：{{item.followUpPurpose}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.followUpResult">跟进结果：{{item.followUpResult}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.customerPromise">给客户的承诺：{{item.customerPromise}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.customerBasicInfo">客户基础信息：{{item.customerBasicInfo}}</div>
              <div class="follow-up-img-scroll mt10" v-if="item.followUpUrl && item.followUpUrlList.length">
                <el-image v-for="(it, idx) in item.followUpUrlList" :key="idx" style="width: 50px; height: 50px;border-radius: 4px;flex-shrink:0;" class="mr10" :src="it" :preview-src-list="item.followUpUrlList"></el-image>
                <span v-if="item.followUpUrlList.length > 3" class="img-count-badge" @click.stop>(void 0)">共{{item.followUpUrlList.length}}张</span>
              </div>
              <div class="mt10 c-8F8E8E" v-if="item.followUpTime">跟进时间：{{item.followUpTime}}</div>
              <div class="mt10 c-8F8E8E">下次跟进时间：{{item.nextFollowUpTime}}</div>
            </div>
          </el-timeline-item>
        </el-timeline>
        <Empty v-if="!customerList.length">该客户暂无跟进信息～</Empty>
      </template>
      <!-- 技术跟进 -->
      <template v-if="activeName==8">
        <el-timeline v-if="techList.length">
          <el-timeline-item v-for="(item, index) in techList" :key="index" type="primary">
            <div class="boxs">
              <div class="flexs justify-between mb10">
                <span class="c-8F8E8E">{{item.createdTime}} 星期{{setWeek(dayjs(item.createdTime).day())}}</span>
                <span class="c-8F8E8E" v-if="item.followUpByRealName">跟进人：{{item.followUpByRealName}}<template v-if="item.followUpByType">（{{item.followUpByType}}）</template></span>
              </div>
              <div class="mt10 c-8F8E8E" v-if="item.followUpCategoryId">跟进类型：{{getFollowUpCategoryName(item.followUpCategoryId)}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.followUpType">跟进方式：{{item.followUpType==1?'线下会面':'线上沟通'}}</div>
              <div class="mt10 c-8F8E8E">跟进内容：{{item.followUpContent}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.professionalEmpowerment" style="white-space: pre-wrap">专业赋能：{{item.professionalEmpowerment}}</div>
              <followup-portrait-fields :record="item" />
              <div class="mt10 c-8F8E8E" v-if="item.followUpPurpose">跟进目的：{{item.followUpPurpose}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.followUpResult">跟进结果：{{item.followUpResult}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.customerPromise">给客户的承诺：{{item.customerPromise}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.customerBasicInfo">客户基础信息：{{item.customerBasicInfo}}</div>
              <div class="follow-up-img-scroll mt10" v-if="item.followUpUrl && item.followUpUrlList.length">
                <el-image v-for="(it, idx) in item.followUpUrlList" :key="idx" style="width: 50px; height: 50px;border-radius: 4px;flex-shrink:0;" class="mr10" :src="it" :preview-src-list="item.followUpUrlList"></el-image>
                <span v-if="item.followUpUrlList.length > 3" class="img-count-badge" @click.stop>(void 0)">共{{item.followUpUrlList.length}}张</span>
              </div>
              <div class="mt10 c-8F8E8E" v-if="item.followUpTime">跟进时间：{{item.followUpTime}}</div>
              <div class="mt10 c-8F8E8E">下次跟进时间：{{item.nextFollowUpTime}}</div>
            </div>
          </el-timeline-item>
        </el-timeline>
        <Empty v-if="!techList.length">该客户暂无跟进信息～</Empty>
      </template>
      <!-- 服务跟进 -->
      <template v-if="activeName==11">
        <el-timeline v-if="serviceList.length">
          <el-timeline-item v-for="(item, index) in serviceList" :key="index" type="primary">
            <div class="boxs">
              <div class="flexs justify-between mb10">
                <span class="c-8F8E8E">{{item.createdTime}} 星期{{setWeek(dayjs(item.createdTime).day())}}</span>
                <span class="c-8F8E8E" v-if="item.followUpByRealName">跟进人：{{item.followUpByRealName}}<template v-if="item.followUpByType">（{{item.followUpByType}}）</template></span>
              </div>
              <div class="mt10 c-8F8E8E" v-if="item.followUpCategoryId">跟进类型：{{getFollowUpCategoryName(item.followUpCategoryId)}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.followUpType">跟进方式：{{item.followUpType==1?'线下会面':'线上沟通'}}</div>
              <div class="mt10 c-8F8E8E">跟进内容：{{item.followUpContent}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.professionalEmpowerment" style="white-space: pre-wrap">专业赋能：{{item.professionalEmpowerment}}</div>
              <followup-portrait-fields :record="item" />
              <div class="mt10 c-8F8E8E" v-if="item.followUpPurpose">跟进目的：{{item.followUpPurpose}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.followUpResult">跟进结果：{{item.followUpResult}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.customerPromise">给客户的承诺：{{item.customerPromise}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.customerBasicInfo">客户基础信息：{{item.customerBasicInfo}}</div>
              <div class="follow-up-img-scroll mt10" v-if="item.followUpUrl && item.followUpUrlList.length">
                <el-image v-for="(it, idx) in item.followUpUrlList" :key="idx" style="width: 50px; height: 50px;border-radius: 4px;flex-shrink:0;" class="mr10" :src="it" :preview-src-list="item.followUpUrlList"></el-image>
                <span v-if="item.followUpUrlList.length > 3" class="img-count-badge" @click.stop>(void 0)">共{{item.followUpUrlList.length}}张</span>
              </div>
              <div class="mt10 c-8F8E8E" v-if="item.followUpTime">跟进时间：{{item.followUpTime}}</div>
              <div class="mt10 c-8F8E8E">下次跟进时间：{{item.nextFollowUpTime}}</div>
            </div>
          </el-timeline-item>
        </el-timeline>
        <Empty v-if="!serviceList.length">该客户暂无跟进信息～</Empty>
      </template>
      <template v-if="activeName==12">
        <el-timeline v-if="otherList.length">
          <el-timeline-item v-for="(item, index) in otherList" :key="index" type="primary">
            <div class="boxs">
              <div class="flexs justify-between mb10">
                <span class="c-8F8E8E">{{item.createdTime}} 星期{{setWeek(dayjs(item.createdTime).day())}}</span>
                <span class="c-8F8E8E" v-if="item.followUpByRealName">跟进人：{{item.followUpByRealName}}<template v-if="item.followUpByType">（{{item.followUpByType}}）</template></span>
              </div>
              <div class="mt10 c-8F8E8E" v-if="item.followUpCategoryId">跟进类型：{{getFollowUpCategoryName(item.followUpCategoryId)}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.followUpType">跟进方式：{{item.followUpType==1?'线下会面':'线上沟通'}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.followUpPurpose">跟进目的：{{item.followUpPurpose}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.followUpContent">跟进内容：{{item.followUpContent}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.followUpResult">跟进结果：{{item.followUpResult}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.customerPromise">给客户的承诺：{{item.customerPromise}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.customerBasicInfo">客户基础信息：{{item.customerBasicInfo}}</div>
              <div class="follow-up-img-scroll mt10" v-if="item.followUpUrl && item.followUpUrlList.length">
                <el-image v-for="(it, idx) in item.followUpUrlList" :key="idx" style="width: 50px; height: 50px;border-radius: 4px;flex-shrink:0;" class="mr10" :src="it" :preview-src-list="item.followUpUrlList"></el-image>
                <span v-if="item.followUpUrlList.length > 3" class="img-count-badge" @click.stop>(void 0)">共{{item.followUpUrlList.length}}张</span>
              </div>
              <div class="mt10 c-8F8E8E" v-if="item.followUpTime">跟进时间：{{item.followUpTime}}</div>
              <div class="mt10 c-8F8E8E" v-if="item.nextFollowUpTime">下次跟进时间：{{item.nextFollowUpTime}}</div>
            </div>
          </el-timeline-item>
        </el-timeline>
        <Empty v-if="!otherList.length">该客户暂无其他跟进信息～</Empty>
      </template>
      <template v-if="activeName==9">
        <Title class="mt20">客户兴趣</Title>
        <echarts-vue :echart-data="echartData" echartName="echarts" />
        <Title class="mt20">互动记录</Title>
        <div class="flexs justify-between">
          <div>互动明细</div>
          <el-date-picker v-model="times" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" @change="getList">
          </el-date-picker>
        </div>
        <el-tabs v-model="tabActive" @tab-click="getList">
          <el-tab-pane label="全部" name="0"></el-tab-pane>
          <el-tab-pane label="商城" name="1"></el-tab-pane>
          <el-tab-pane label="课程" name="2"></el-tab-pane>
          <el-tab-pane label="项目管理" name="3-2"></el-tab-pane>
          <el-tab-pane label="分享物料" name="3-1"></el-tab-pane>
          <el-tab-pane label="业务物料" name="3-5"></el-tab-pane>
          <el-tab-pane label="顾客物料" name="3-3"></el-tab-pane>
          <el-tab-pane label="案例展示" name="3-4"></el-tab-pane>
          <el-tab-pane label="皮科普药" name="3-7"></el-tab-pane>
          <el-tab-pane label="品宣" name="3-6"></el-tab-pane>
          <el-tab-pane label="新闻资讯" name="3-8"></el-tab-pane>
        </el-tabs>
        <div class="boxs mb20" style="border-radius: 8px;" v-for="(item, index) in browseList" :key="`browse-${item.id}-${index}`">
          <div class="flexs justify-between mb10">
            <span>{{getBrowsingTypeName(item.browsingType, item.classifyName)}}</span>
            <span>{{item.createdTime}}</span>
          </div>
          <span class="c-8F8E8E">标题：{{item.headline}}</span>
          <div class="mt10 c-8F8E8E">浏览时长：{{formatBrowsingTime(item.browsingTime)}}</div>
        </div>
        <Empty v-if="!browseList.length">该客户无互动明细～</Empty>
      </template>
      <template v-if="activeName==10">
        <Title class="mt20">店铺介绍</Title>
        <div class="boxs mb20" style="border-radius: 8px;" v-if="storeInfo">
          <div class="flexs mb10">
            <span>店铺名称：</span>
            <span>{{storeInfo.storeName}}</span>
          </div>
          <div class="flexs mb10">
            <span>店铺图：</span>
            <div v-if="storeInfo.storeUrl">
              <el-image class="banner-box" v-for="(item,index) in storeInfo.storeUrl && storeInfo.storeUrl.split(',')" :key="index" :src="item" :preview-src-list="[item]"></el-image>
            </div>
          </div>
          <div class="flexs mb10">
            <span>店铺介绍：</span>
            <span>{{storeInfo.storeIntro}}</span>
          </div>
        </div>
        <Empty v-if="!storeInfo">该客户暂无店铺介绍～</Empty>
      </template>
    </el-card>
  </div>
</template>

<script>
import echartsVue from './echarts.vue'
import otherFollowCustRecordApi from '@/api/client/otherFollowCustRecord'
import clientListApi from '@/api/client/clientList'
import customerLevelApi from '@/api/sys/customerLevel'
import userApi from '@/api/user'
import businessProcessingApi from '@/api/user/businessProcessing'
import technicianInfoApi from '@/api/technical/technicianInfo'
import meetingSignUpApi from '@/api/meeting/meetingSignUp'
import courseSubjectApi from '@/api/course/courseSubject'
import userStoreApi from '@/api/archives/userStore'
import sysDataconstantApi from '@/api/config/sysDataconstant'
import dayjs from 'dayjs'
import portraitRecords from './portraitRecords.vue'
import PortraitSummary from './portraitSummary.vue'
import FollowupPortraitFields from './followupPortraitFields.vue'
export default {
  props: ['rowId'],
  data() {
    return {
      storeInfo: null,
      contractList: [],
      subaccountInfo: {
        submitterCustomerPO: {}
      },
      info: {
        customerPO: {},
        userPO: {},
        parent: {},
        technician: {},
      },
      allStatistics: {
        goodsPayMoney: 0,
        moneyForPayType1: 0,
        moneyForPayType2: 0,
        moneyForPayType4: 0,
        moneyForPayType5: 0
      },
      orderStatistics: {
        goodsPayMoney: 0,
        moneyForPayType1: 0,
        moneyForPayType2: 0,
        moneyForPayType4: 0,
        moneyForPayType5: 0
      },
      seckillStatistics: {
        goodsPayMoney: 0,
        moneyForPayType1: 0,
        moneyForPayType2: 0,
        moneyForPayType4: 0,
        moneyForPayType5: 0
      },
      // 月度出货业绩：后端固定返回 1~12 月，缺月补 0
      monthYear: new Date().getFullYear(),
      monthList: [],
      monthLoading: false,
      meetingInfo: {
        count: 0,
        signInCount: 0,
        notSignInCount: 0,
        fee: 0
      },
      echartData: {},
      listLoading: true,
      list: [],
      customerList: [],
      techList: [],
      serviceList: [],
      otherList: [],
      browseList: [],
      followUpCategoryList: [],
      query: {
        pageNo: 1,
        pageSize: 10,
        customerType: 3,
        isOpenSea: 0
      },
      options: [],
      standingList: [],
      customerLine: '',
      technicianLine: '',
      activeName: '1',
      tabActive: '0',
      walletInfo: {
        balance: 0,
        xiaoduMoney: 0,
        tuition: 0,
        integral: 0
      },
      courseInfo: {
        buyCount: 0,
        giveCount: 0,
        totalPayAmount: 0
      },
      times: '',
      stepList: [{
        id: 0,
        label: '未参会',
        isActive: true
      },
      {
        id: 1,
        label: '已参加推介会',
        isActive: false
      },
      {
        id: 2,
        label: '已参加专题课',
        isActive: false
      },
      {
        id: 3,
        label: '持续跟进',
        isActive: false
      },
      {
        id: 4,
        label: '已报名研修班',
        isActive: false
      },
      ]
    }
  },
  components: { echartsVue, portraitRecords, PortraitSummary, FollowupPortraitFields },
  computed: {
    // 年份下拉：当年往前 5 年，够看历史又不至于拉太长
    yearOptions() {
      const now = new Date().getFullYear()
      return Array.from({ length: 6 }, (_, i) => now - i)
    },
    setWeek() {
      return function (val) {
        switch (val) {
          case 1:
            return "一";
            break;
          case 2:
            return "二";
            break;
          case 3:
            return "三";
            break;
          case 4:
            return "四";
            break;
          case 5:
            return "五";
            break;
          case 6:
            return "六";
            break;
          case 0:
            return "日";
            break;
        }
      }

    }
  },
  async created() {
    this.times = dayjs(new Date()).format("YYYY-MM-DD")
    await this.getBusinessStanding()
    await this.getStandingList()
    await this.getDetail()
    this.getOrder()
    this.getMonthStatistics()
    this.getCustomerList()
    this.getTechList()
    this.getServiceList()
    this.getOtherList()
    this.getWallet()
    this.getBrowse()
    this.getList()
    this.getMeeting()
    this.getCourse()
    this.getStoreDeatils()
    this.loadFollowUpCategoryList()
    this.doQueryList({
      pageNo: 1
    })
    // this.handleShow()
    // if (this.technicalState) this.getShareData()
  },
  methods: {
    formatContractExpiration(value) {
      if (typeof value !== 'string') return '-'
      const localTime = value.trim().replace('T', ' ')
      if (!/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(?:\.\d{1,9})?$/.test(localTime)) return '-'
      const seconds = localTime.slice(0, 19)
      const date = dayjs(seconds)
      const formatted = date.format('YYYY-MM-DD HH:mm:ss')
      return date.isValid() && formatted === seconds ? formatted : '-'
    },
    contractUrl(value) {
      if (typeof value !== 'string') return ''
      try {
        const url = new URL(value)
        return url.protocol === 'https:' && !url.username && !url.password ? url.href : ''
      } catch (error) {
        return ''
      }
    },
    // 获取实名认证状态颜色
    getCertStatusColor(certificatesPO, auditStatus) {
      if (!certificatesPO) return '#E73F3F' // 未认证 - 红色
      switch (auditStatus) {
        case 1: return '#0D862F' // 已认证 - 绿色
        case 0: return '#E5A823' // 待审核 - 黄色
        case -1: return '#E73F3F' // 驳回 - 红色
        default: return '#E73F3F'
      }
    },
    // 获取实名认证状态文本
    getCertStatusText(certificatesPO, auditStatus) {
      if (!certificatesPO) return '未认证'
      switch (auditStatus) {
        case 1: return '已认证'
        case 0: return '待审核'
        case -1: return '已驳回'
        default: return '未认证'
      }
    },
    // 加载跟进类型列表
    loadFollowUpCategoryList() {
      sysDataconstantApi.fetchCode({ code: 'addfollowCustRecordType' }).then(({ data }) => {
        if (data && data.content) {
          const content = data.content.trim()
          if (content.startsWith('[')) {
            // 旧格式：JSON数组
            this.followUpCategoryList = JSON.parse(content)
          } else {
            // 新格式：逗号分隔字符串
            this.followUpCategoryList = content.split(',').map(s => s.trim()).filter(Boolean)
          }
        } else {
          this.followUpCategoryList = []
        }
      }).catch(() => {
        this.followUpCategoryList = []
      })
    },
    // 根据ID获取跟进类型名称
    getFollowUpCategoryName(id) {
      if (!id) return ''
      if (this.followUpCategoryList.length === 0) return id
      // 新格式：逗号分隔字符串，按索引匹配
      if (typeof this.followUpCategoryList[0] === 'string') {
        const idx = Number(id)
        return (idx >= 0 && idx < this.followUpCategoryList.length) ? this.followUpCategoryList[idx] : id
      }
      // 旧格式：JSON数组 [{id, name, enable}]
      const item = this.followUpCategoryList.find(c => String(c.id) === String(id))
      return item ? item.name : id
    },
    getStoreDeatils() {
      userStoreApi.getUserStoreByCustomerId(this.info.customerPO.id).then(res => {
        let data = res.data;
        this.storeInfo = data
      })
    },
    // 获取客户身份
    getStandingList() {
      // 必须把 Promise 返回出去：getDetail 依赖 standingList，不 await 就是竞态
      return customerLevelApi.fetchList({ type: 3 }).then(({ data }) => {
        this.standingList = data
      })
    },
    // 获取会议统计
    async getMeeting() {
      const { data } = await meetingSignUpApi.getCountFeeByUserInfo({ userInfoId: this.info.customerPO.id, userType: 20 })
      if (data) {
        for (let key in this.meetingInfo) {
          if (this.meetingInfo.hasOwnProperty(key)) { // 确保key是对象自身的属性
            if (data[key]) {
              this.meetingInfo[key] = data[key]
            }
          }
        }
      }
      // this.meetingInfo=data
      console.log('会议: ', data);
    },
    async getCourse() {
      const { data } = await courseSubjectApi.getCourseSubjectStatistics({ userId: this.info.customerPO.userId })
      for (let key in this.courseInfo) {
        if (this.courseInfo.hasOwnProperty(key)) { // 确保key是对象自身的属性
          if (data[key]) {
            this.courseInfo[key] = data[key]
          }
        }
      }
      console.log('课程', data)
    },
    // 订单统计
    async getOrder() {
      const { data } = await clientListApi.getStatisticsByTypeGroup(this.info.customerPO.id)
      if (data.length) {
        data.map(item => {
          for (let key in this.allStatistics) {
            if (this.allStatistics.hasOwnProperty(key)) { // 确保key是对象自身的属性
              if (item[key]) {
                if (!item.type) {
                  this.allStatistics[key] = item[key]
                }
                if (item.type == 1) {
                  this.orderStatistics[key] = item[key]
                }
                if (item.type == 3) {
                  this.seckillStatistics[key] = item[key]
                }
              }
            }
          }
        })
      }
    },
    /**
     * 月度出货业绩
     * 口径与「订单统计」一致（订货单+秒杀单，已发货/已收货/已完成），业绩不含运费
     */
    async getMonthStatistics() {
      const id = this.info.customerPO && this.info.customerPO.id
      if (!id) return
      this.monthLoading = true
      try {
        const { data } = await clientListApi.getStatisticsByMonthGroup(id, this.monthYear)
        this.monthList = data || []
      } finally {
        this.monthLoading = false
      }
    },
    // 合计行：只剩单量求和。
    // REQ-2026-911648 去掉业绩列后，原来那个兜底的 else 分支（业绩求和）已永不执行，
    // 留着会在以后有人加列时把新列悄悄填成业绩合计，所以一并删掉。
    monthSummary({ columns, data }) {
      const sums = []
      columns.forEach((col, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 1) {
          sums[index] = data.reduce((acc, cur) => acc + Number(cur.orderCount || 0), 0)
          return
        }
        sums[index] = ''
      })
      return sums
    },
    // 获取浏览统计
    async getBrowse() {
      const { data } = await userApi.getAllCount({ userId: this.info.customerPO.userId })
      this.echartData = data
      console.log('统计data: ', data);
    },
    // 获取浏览记录列表
    async getList() {
      let obj = {
        userId: this.info.customerPO.userId,
        pageNo: 1, 
        pageSize: 999
      }
      
      // 处理 tab 选择
      if (this.tabActive != '0') {
        // 如果 tabActive 包含 '-'，说明是营销类型，格式为 "3-sourceType"
        if (this.tabActive.includes('-')) {
          const [browsingType, sourceType] = this.tabActive.split('-')
          obj.browsingType = parseInt(browsingType)
          obj.sourceType = parseInt(sourceType)
        } else {
          // 商城(1) 或 课程(2)
          obj.browsingType = parseInt(this.tabActive)
        }
      }
      
      if (this.times) {
        obj.startTime = `${this.times} 00:00:00`
        obj.endTime = `${this.times} 23:59:59`
      }
      
      const { data } = await userApi.getBrowsingHistoryPageList(obj)
      this.browseList = data.list || []
      // console.log('浏览data: ',data);
    },
    // 获取浏览类型名称
    getBrowsingTypeName(browsingType, classifyName) {
      if (browsingType == 1) {
        return '浏览商品'
      } else if (browsingType == 2) {
        return '浏览课程'
      } else if (browsingType == 3) {
        // 营销类型，根据 sourceType 返回对应名称
        const sourceTypeMap = {
          1: '分享物料',
          2: '项目管理',
          3: '顾客物料',
          4: '案例展示',
          5: '业务物料',
          6: '品宣',
          7: '皮科普药',
          8: '新闻资讯'
        }
        return `浏览${sourceTypeMap[classifyName] || '营销内容'}`
      }
      return '浏览记录'
    },
    // 格式化浏览时长
    formatBrowsingTime(seconds) {
      if (!seconds) return '0秒'
      if (seconds < 60) {
        return `${seconds}秒`
      }
      const minutes = Math.floor(seconds / 60)
      const remainingSeconds = seconds % 60
      if (remainingSeconds === 0) {
        return `${minutes}分钟`
      }
      return `${minutes}分${remainingSeconds}秒`
    },
    // 获取用户钱包
    async getWallet() {
      const { data } = await clientListApi.getUserWallet({ customerId: this.info.customerPO.id })
      if (data) {
        for (let key in this.walletInfo) {
          if (this.walletInfo.hasOwnProperty(key)) { // 确保key是对象自身的属性
            if (data[key]) {
              this.walletInfo[key] = data[key]
            }
          }
        }
      }
      // console.log('钱包data: ',data);
    },
    // 业务跟进
    async getCustomerList() {
      const {
        data
      } = await clientListApi.followCustRecord({
        customerId: this.info.customerPO.id
      })
      // console.log('进度: ',data);
      this.customerList = data.list.map(item => {
        if (item.followUpUrl) {
          item.followUpUrlList = item.followUpUrl.split(',')
        }
        return item
      })
    },
    // 技术跟进
    async getTechList() {
      const {
        data
      } = await technicianInfoApi.techFollowCustRecord({
        custId: this.info.customerPO.id
      })
      // console.log('进度: ',data);
      this.techList = data.list.map(item => {
        if (item.followUpUrl) {
          item.followUpUrlList = item.followUpUrl.split(',')
        }
        return item
      })
    },
    // 服务跟进
    async getServiceList() {
      const {
        data
      } = await technicianInfoApi.techFollowCustRecord({
        custId: this.info.customerPO.id,
        isBigCustomer: true,
        isOrdinary: false
      })
      // console.log('服务跟进: ',data);
      this.serviceList = data.list.map(item => {
        if (item.followUpUrl) {
          item.followUpUrlList = item.followUpUrl.split(',')
        }
        return item
      })
    },
    // 其他跟进
    async getOtherList() {
      const { data } = await otherFollowCustRecordApi.fetchList({ customerId: this.info.customerPO.id, pageNo: 1, pageSize: 999 })
      this.otherList = (data.list || []).map(item => {
        if (item.followUpUrl) {
          item.followUpUrlList = item.followUpUrl.split(',')
        }
        return item
      })
    },
    async getDetail() {
      const {
        data
      } = await clientListApi.fetchByIdDetail({ customerId: this.rowId })
      // const {data}=await clientListApi.fetchById(91)
      this.info = data
      // 兜底：匹配不到客户身份时不能抛，否则 created() 中断，订单统计/月度业绩等全部不加载
      const _standing = this.standingList.find(i => i.level == data.customerPO.clevel)
      this.info.customerPO.clevelName = _standing ? _standing.name : ''
      // this.info.lineList.splice(0, 1)
      // if (this.info.contractList && this.info.contractList.length) {
      //   this.contractList = this.info.contractList.splice(0, 1)
      // }
      if (this.info.customerPO.mainId) {
        this.getSubaccount()
      }
      if (this.info.customerLine && this.info.customerLine.length) {
        this.info.customerLine.splice(0, 1)
        this.info.customerLine.sort((a, b) => b.clevel - a.clevel)
        let arr = []
        arr = this.info.customerLine.map(i => {
          const _lv = this.options.find(it => it.level == i.clevel)
          return _lv ? `${i.name}【${_lv.name}】` : `${i.name}`
        })
        if (arr.length) {
          this.customerLine = this.info.customerPO.name + '【' + this.info.customerPO.clevelName + '】- ' + arr.join(' - ')
        } else {
          this.customerLine = this.info.customerPO.name + '【' + this.info.customerPO.clevelName + '】'
        }

      }
      if (this.info.technicianList && this.info.technicianList.length) {
        // this.info.technicianList.sort((a, b) => b.clevel - a.clevel)
        let arr = []
        if (this.info.technicianList.length) {
          arr = this.info.technicianList.map(i => (`${i.realName}【${i.levelName}】`))
        }
        if (arr.length) {
          this.technicianLine = this.info.customerPO.name + '【' + this.info.customerPO.clevelName + '】- ' + arr.join(' - ')
        } else {
          this.technicianLine = this.info.customerPO.name + '【' + this.info.customerPO.clevelName + '】'
        }

      }
      this.stepList.map(i => {
        if (this.info.customerPO.clevel == 6) {
          i.isActive = true
        }
        if ((this.info.diqupeixunhui || this.info.customerPO.clevel == 7) && i.id <= 3) {
          i.isActive = true
        } else {
          if (this.info.tuijianhui && this.info.zhuantihui && i.id <= 2) {
            i.isActive = true
          }
          if (this.info.tuijianhui && !this.info.zhuantihui && i.id <= 1) {
            i.isActive = true
          }
          if (!this.info.tuijianhui && this.info.zhuantihui && [0, 2].includes(i.id)) {
            i.isActive = true
          }
        }
        return
      })
      this.stepList.sort((val, val2) => { if (val2.isActive * 1 < val.isActive * 1) return -1; if (val2.isActive * 1 > val.isActive * 1) return 1; return val.id - val2.id; })
      console.log('详情:----------- ', this.info);
    },
    async getSubaccount() {
      const { data } = await businessProcessingApi.findSubAccountApplyInfo({ customerId: this.rowId })
      this.subaccountInfo = data
      console.log('子账号data: ', data);
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    },
    /**
     * 执行列表查询
     */
    doQueryList({
      pageNo,
      pageSize
    }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      // console.log('this.query: ',this.query,this.dateTime);
      // return
      let query = {
        ...this.query,
        mainId: this.rowId
      }
      if (this.query.timeType && this.dateTime && this.dateTime.length) {
        query.startTime = this.dateTime[0]
        query.endTime = this.dateTime[1]
      }
      if (this.dateTime && this.dateTime.length && !this.query.timeType) {
        this.dateTime = null
      }
      // return
      // this.query.displayPosition=this.activeName
      this.listLoading = true
      return clientListApi.fetchList(query)
        .then(({
          data
        }) => {
          console.log("data111111111: ", data);
          this.list = data.list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    // 将门店类型数字转换为中文名称
    getCompanyTypeName(companyType) {
      const companyTypeMap = {
        0: '诊所',
        1: '私立医院',
        2: '卫生室',
        3: '单体店',
        4: '社区卫生服务站',
        5: '美容院'
      }
      // 如果传入的是字符串，直接返回；如果是数字，返回对应中文名称；否则返回原值
      if (typeof companyType === 'string' && isNaN(companyType)) {
        return companyType
      }
      const num = Number(companyType)
      return companyTypeMap[num] !== undefined ? companyTypeMap[num] : companyType
    },
    // 获取业务员身份
    getBusinessStanding() {
      // 同上：getDetail 里拼客户线要用 this.options
      return customerLevelApi.fetchList({
        type: 2
      }).then(({
        data
      }) => {
        this.options = data
      })
    },
  }

}
</script>

<style lang="scss" scoped>
.banner-box {
  width: 50px;
  height: 50px;
  margin: 2px;
}
.box-sty ::v-deep .el-descriptions__body {
  background: #1596cd1a;
}
a:hover {
  color: #60b7dc;
}
// 跟进详情字段标题加粗
.boxs {
  .c-8F8E8E {
    color: #4a4a4a;
    font-weight: 600;
  }
}
// 图片水平滚动
.follow-up-img-scroll {
  display: flex;
  overflow-x: auto;
  flex-wrap: nowrap;
  max-width: 220px;
  &::-webkit-scrollbar { display: none; }
}
.img-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  height: 50px;
  padding: 0 6px;
  background: rgba(0,0,0,0.5);
  color: #fff;
  font-size: 11px;
  font-weight: bold;
  border-radius: 4px;
  flex-shrink: 0;
  cursor: default;
}

.boxs {
  width: 97%;
  padding: 20px;
  box-shadow: 0px 0px 4px 0px #00000040;
}

.label-box {
  background: #1596cd1a;
  padding: 2px;
  border-radius: 2px;
  color: #1596cd;
}

.label-boxs {
  background: #c8ab0e1a;
  padding: 2px 4px;
  border-radius: 2px;
  color: #c8ab0e;
}

.step-box {
  width: 160px;
  height: 44px;
  margin-right: 10px;

  ::v-deep .el-image {
    width: 160px;
    height: 44px;
  }

  div {
    left: 0;
    top: 0;
  }
}

::v-deep.el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 14px;
}
</style>
